// Currency code to symbol mapping
const currencySymbols: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CNY: "¥",
  KRW: "₩",
  INR: "₹",
  RUB: "₽",
  BRL: "R$",
  CAD: "C$",
  AUD: "A$",
  CHF: "Fr",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  PLN: "zł",
  CZK: "Kč",
  HUF: "Ft",
  TRY: "₺",
  ZAR: "R",
  MXN: "$",
  SGD: "S$",
  HKD: "HK$",
  NZD: "NZ$",
  THB: "฿",
  PHP: "₱",
  IDR: "Rp",
  MYR: "RM",
  VND: "₫",
  AED: "د.إ",
  SAR: "﷼",
  ILS: "₪",
  EGP: "£",
  NGN: "₦",
  COP: "$",
  ARS: "$",
  CLP: "$",
  PEN: "S/",
  TWD: "NT$",
  PKR: "₨",
  BDT: "৳",
  UAH: "₴",
  RON: "lei",
  BGN: "лв",
  HRK: "kn",
};

/**
 * Get the currency symbol for a given currency code
 * Falls back to the code itself if not found
 */
export function getCurrencySymbol(currencyCode: string | null | undefined): string {
  if (!currencyCode) return "$";
  const code = currencyCode.toUpperCase();
  return currencySymbols[code] || code;
}

/**
 * Format a price with the appropriate currency symbol
 */
export function formatPrice(
  amount: number | null | undefined,
  currencyCode: string | null | undefined
): string {
  if (amount === null || amount === undefined) return "-";
  const symbol = getCurrencySymbol(currencyCode);
  return `${symbol}${amount.toFixed(2)}`;
}
